import { Flex, Text, Button } from "@chakra-ui/react";
import React from "react";
import { SettingRowBase } from "./SettingRowBase";

interface ReadOnlySettingRowProps {
  label: string;
  description?: string;
  value: string;
  onCopy?: () => void;
}

export function ReadOnlySettingRow({
  label,
  description,
  value,
  onCopy,
}: ReadOnlySettingRowProps) {
  return (
    <SettingRowBase label={label} description={description}>
      <Flex w="full" alignItems="flex-start" gap={3} wrap="wrap">
        <Text>{value}</Text>

        {onCopy && value && (
          <Button
            variant="outline"
            backgroundColor="white"
            size="sm"
            onClick={onCopy}
          >
            Copy
          </Button>
        )}
      </Flex>
    </SettingRowBase>
  );
}
